import { render, staticRenderFns } from "./BannerInfo.vue?vue&type=template&id=79994d3b"
import script from "./BannerInfo.vue?vue&type=script&lang=js"
export * from "./BannerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports